export function pipe (...fns) {
  return function (x) {
    return fns.reduce((result, fn) => fn(result), x);
  };
}

export function compose (...fns) {
  return function (x) {
    return fns.reduceRight((result, fn) => fn(result), x);
  };
}

export function debounce (fn, timeout = 300) {
  let timer;

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { fn.apply(this, args); }, timeout);
  };
}

/**
 * Debouncing the other way around
 * Ignore subsequent calls until the timeout has expired
 */
export function debounceLeading (fn, timeout = 300) {
  let timer;

  return (...args) => {
    if (!timer) {
      fn.apply(this, args);
    }

    clearTimeout(timer);

    timer = setTimeout(() => {
      timer = undefined;
    }, timeout);
  };
}

export function throttle (fn, timeFrame) {
  let lastTime = 0;
  return function (...args) {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      fn(...args);
      lastTime = now;
    }
  };
}

export function memoize (fn) {
  const cache = new Map();

  return (...args) => {
    const key = JSON.stringify(args);

    if (cache.has(key)) {
      return cache.get(key);
    }

    const result = fn(...args);
    cache.set(key, result);

    return result;
  };
}

export function convertPixelToRem (pixel, rootSize) {
  return pixel * 1000 / rootSize;
}

export function convertRemToPixel (rem, rootSize) {
  return rem / 1000 * rootSize;
}

export function getRotationCenter (selected) {
  if (!selected.hasAttribute('transform')) return { x: null, y: null };

  const transform = selected.getAttribute('transform');
  const regexp = /rotate\(([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?)\)/gi;
  const matchResult = regexp.exec(transform);
  const xCenter = matchResult
    ? matchResult[3]
    : 0;
  const yCenter = matchResult
    ? matchResult[5]
    : 0;

  return {
    x: xCenter,
    y: yCenter
  };
}

export function convertNumberToPercentage (number) {
  return parseFloat(number) / 100;
}
